import { Typography, TypographyProps } from "@material-ui/core";
import classNames from "classnames";
import React, { ElementType } from "react";

import useMyTypographyStyle from "./MyTypography.styles";

interface IMyTypography extends Omit<TypographyProps, "variant"> {
  variant:
    | TypographyProps["variant"]
    | "h7"
    | "subtitle3"
    | "body3"
    | "button2"
    | "button3"
    | "captionBold";
  component?: ElementType;
}
const MyTypography: React.FC<IMyTypography> = props => {
  const classes = useMyTypographyStyle();
  const isCustom = Object.keys(classes).indexOf(props.variant) > -1;
  return (
    <Typography
      {...props}
      variant={isCustom ? undefined : (props.variant as any)}
      className={
        isCustom
          ? classNames(classes[props.variant], props.className)
          : props.className
      }
    >
      {props.children}
    </Typography>
  );
};

export default MyTypography;
